import { infotp2formulaeditor_left } from './infotp2formulaeditor_left.js';

class CellTemplate {
    cellIsTemplate = "";
    cellTemplateIsUse = "";
    celltemplateChannel = "";
    celltemplateValue = "";
    cellTemplateOperatorBefore = "";
    cellTemplateOperatorAfter = "";

    constructor(cellIsTemplate, cellTemplateIsUse, templateChannel, templateValue, cellTemplateOperatorBefore, cellTemplateOperatorAfter) {
        this.cellIsTemplate = cellIsTemplate;
        this.cellTemplateIsUse = cellTemplateIsUse;
        this.cellTemplateChannel = templateChannel;
        this.cellTemplateValue = templateValue;
        this.cellTemplateOperatorBefore = cellTemplateOperatorBefore;
        this.cellTemplateOperatorAfter = cellTemplateOperatorAfter;
    }
}

class infotp2formulaeditor extends Tango.Component {

    /*
    static ti_Icon = '<svg class="svgicon-askue_ti"><use xlink:href="/data/icons/svg#icon-askue_ti"></use></svg>';
    static cti_Icon = '<svg class="svgicon-askue_contr_ti"><use xlink:href="/data/icons/svg#icon-askue_contr_ti"></use></svg>';
    static function_Icon = '<svg class="svgicon-function"><use xlink:href="/data/icons/svg#icon-function"></use></svg>';
    */

    static backColorSelect = "yellow";
    static backColorTemplate = "LightGray";

    CellTemplates = [];

    widgetDidMount() {
        var _this = this;



        _this.onChangeFormula();
        ///TODO: переделать на ID
        var table = document.querySelector("table[data-tformuladesc]");
        if (table) {
            table.infotp2formulaeditor = this;
            table.querySelectorAll("a[data-removerow]").forEach(function (a) {
                a.addEventListener("click", function () {
                    _this.removerow();
                });
            });

            table.querySelectorAll("a[data-moverowup]").forEach(function (a) {
                a.addEventListener("click", function () {
                    _this.moverowup();
                });
            });

            table.querySelectorAll("a[data-moverowdown]").forEach(function (a) {
                a.addEventListener("click", function () {
                    _this.moverowdown();
                });
            });

            table.querySelectorAll("a[data-addrowup]").forEach(function (a) {
                a.addEventListener("click", function () {
                    _this.addrowup();
                });
            });

            table.querySelectorAll("a[data-addrowdown]").forEach(function (a) {
                a.addEventListener("click", function () {
                    _this.addrowdown();
                });
            });

            table.querySelectorAll("a[data-editOperBefore]").forEach(function (a) {
                a.addEventListener("click", function () {
                    _this.editOperand("Before");
                });
            });

            table.querySelectorAll("a[data-editOperAfter]").forEach(function (a) {
                a.addEventListener("click", function () {
                    _this.editOperand("After");
                });
            });

            table.querySelectorAll("input[data-tbOperAfter='']").forEach(function (a) {
                a.addEventListener("focusout", function () {
                    _this.onLostFocusTbEdit("After");
                });
                a.addEventListener("keypress", function (e) {
                    if (e.keyCode == 13) {
                        _this.onLostFocusTbEdit("After");
                    }
                });
            });
            table.querySelectorAll("input[data-tbOperBefore='']").forEach(function (a) {
                a.addEventListener("focusout", function () {
                    _this.onLostFocusTbEdit("Before");
                });
                a.addEventListener("keypress", function (e) {
                    if (e.keyCode == 13) {
                        _this.onLostFocusTbEdit("Before");
                    }
                });
            });

            table.querySelectorAll("td[data-tdobjectcolumn]").forEach(function (td) {
                td.addEventListener("click", function () {
                    _this.setSelectedRows(td);
                });
            });

            document.querySelectorAll("a[data-ot-ti-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-addti');
                a.addEventListener("click", function () {
                    //_this.addcontract(arg = '' ? null : arg);
                });
            });

            document.querySelectorAll("a[data-ot-cti-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-addcti');
                a.addEventListener("click", function () {
                    //_this.addcontract(arg = '' ? null : arg);
                });
            });

            document.querySelectorAll("a[data-ot-form-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-addform');
                a.addEventListener("click", function () {
                    //_this.addcontract(arg = '' ? null : arg);
                });
            });

            _this.setVisibleUpDownButton();
        }
    }

    setSelectedRows(td) {

        var tr = td.parentElement;

        if (tr.getAttribute("selectinserted") == null) {
            document.querySelectorAll('tr[selectinserted]').forEach(function (r) {
                r.removeAttribute("selectinserted");
                r.style.backgroundColor = null;
                //Check row is template and not apply data
                if (r.getAttribute("cellTemplate") == 1 && r.getAttribute("cellTemplateIsUse") == 0) {
                    r.style.backgroundColor = infotp2formulaeditor.backColorTemplate;
                }
            });
            tr.style.backgroundColor = infotp2formulaeditor.backColorSelect;
            tr.setAttribute("selectinserted", "true");
        }
        else {
            tr.removeAttribute("selectinserted");
            tr.style.backgroundColor = null;
        }
    }

    //TemplateWorkBlock-------------------------------------

    loadTemplate(JSONTemplate) {
        _this = this;
        _this.CellTemplate = JSON.parse(JSONTemplate);
        console.log(_this.CellTemplate);
    }

    setSelectedTemplate(JSONTemplate) {

    }

    addrowdown() {
        var parent = event.currentTarget.parentElement.parentElement;

        var aDelete = parent.querySelector("a[data-removerow]");
        aDelete.style.visibility = "";

        var currnum = parent.getAttribute('data-rid');
        var oldel = document.querySelector("tr[data-rid='" + currnum + "']");
        var newel = document.querySelector("tr[data-rid='" + currnum + "']").cloneNode(true);
        newel.setAttribute("data-newrow", true);

        var spanObject = newel.querySelector("span[data-objectlabel]");
        spanObject.parentNode.style.backgroundColor = "";
        spanObject.style.fontWeight = "";

        parent.parentElement.insertBefore(newel, oldel.nextSibling);
        this.setNewRowProps();
        this.setRowNum();
    }

    //---------------------------------------------------------

    setRowNum() {
        var i = 1;
        var table = document.querySelector("table[data-tformuladesc]");
        table.querySelectorAll('tr[data-rid]').forEach(function (tr) {
            tr.setAttribute("data-rid", i);
            tr.querySelector("span").innerHTML = i++;
        });
        i = 1;
        table.querySelectorAll('a[data-addrowup]').forEach(function (a) {
            a.setAttribute("data-addrowup", i++);
        });
        i = 1;
        table.querySelectorAll('a[data-addrowdown]').forEach(function (a) {
            a.setAttribute("data-addrowdown", i++);
        });
        i = 1;
        table.querySelectorAll('a[data-removerow]').forEach(function (a) {
            a.setAttribute("data-removerow", i++);
        });
        i = 1;
        table.querySelectorAll('a[data-editoperbefore]').forEach(function (a) {
            a.setAttribute("data-editoperbefore", i++);
        });
        i = 1;
        table.querySelectorAll('a[data-editoperafter]').forEach(function (a) {
            a.setAttribute("data-editoperafter", i++);
        });
        var _this = this;
        _this.setVisibleUpDownButton();
        _this.onChangeFormula();
    }

    setVisibleUpDownButton() {
        var table = document.querySelector("table[data-tformuladesc]");
        if (table != null) {
            try {
                table.querySelectorAll("a[data-moverowup]").forEach(function (a) {
                    a.style.visibility = "visible";
                });
                table.querySelectorAll("a[data-moverowdown]").forEach(function (a) {
                    a.style.visibility = "visible";
                });
                if (table.querySelector("tr:first-child").nextSibling != null)
                    table.querySelector("tr:first-child").nextSibling.querySelector("a[data-moverowup]").style.visibility = "hidden";

                if (table.querySelector("tr:last-child").querySelector("a[data-moverowdown]"))
                    table.querySelector("tr:last-child").querySelector("a[data-moverowdown]").style.visibility = "hidden";
            }
            catch (exc) {
                console.log(exc);
            };
        }
    }

    setNewRowProps() {
        var _this = this;
        var row = document.querySelector("tr[data-newrow='true']");
        row.querySelector("span[data-objectlabel]").innerHTML = "";

        row.querySelector("span[data-spanoperafter]").innerHTML = "";
        row.querySelector("span[data-spanoperbefore]").innerHTML = "";

        row.querySelector("input[name='tboperbefore']").innerHTML = "";
        row.querySelector("input[name='tboperafter']").innerHTML = "";
        row.querySelector("input[name='tboperbefore']").setAttribute("value", "");
        row.querySelector("input[name='tboperafter']").setAttribute("value", "");

        var isSelected = row.getAttribute("selectinserted");
        if (isSelected != null && isSelected == "true") {
            row.style.backgroundColor = null;
        }

        row.removeAttribute('data-newrow');
        row.removeAttribute('data-description');
        row.removeAttribute('selectinserted');

        var iconObject = row.querySelector("i[attricon_askue]");
        if (iconObject != null)
            iconObject.innerHTML = null;
        
        var spanObject = row.querySelector("span[data-objectlabel]");
        if (spanObject != null) {
            //Clear TP
            spanObject.removeAttribute('attrdescr-tiid');
            spanObject.removeAttribute('attrdescr-contrtiid');
            spanObject.removeAttribute('attrdescr-formula_un');
            spanObject.removeAttribute('attrdescr-formulasource');
            spanObject.removeAttribute('attrdescr-channel');

            //Clear Section
            spanObject.removeAttribute('attrdescr-iscontractclause');
            spanObject.removeAttribute('attrdescr-iscontract');
            spanObject.removeAttribute('attrdescr-sectionid');
            spanObject.removeAttribute('attrdescr-sectiondataid');   

            //Clear template attribute
            spanObject.removeAttribute('attrdescr-template');
            spanObject.removeAttribute('attrdescr-template-channel-template');
            spanObject.removeAttribute('attrdescr-attrdescr-template-channel-name');
        }

        row.querySelector("a[data-addrowdown]").addEventListener("click", function () {
            _this.addrowdown();
        });

        row.querySelector("input[data-tbOperBefore='']").addEventListener("keypress", function (e) {
            if (e.keyCode == 13) _this.onLostFocusTbEdit("Before");
        });
        row.querySelector("input[data-tbOperAfter='']").addEventListener("keypress", function (e) {
            if (e.keyCode == 13) _this.onLostFocusTbEdit("After");
        });

        row.querySelector("input[data-tbOperAfter='']").addEventListener("focusout", function () {
            _this.onLostFocusTbEdit("After");
        });
        row.querySelector("input[data-tbOperBefore='']").addEventListener("focusout", function () {
            _this.onLostFocusTbEdit("Before");
        });

        row.querySelector("a[data-editOperBefore]").addEventListener("click", function () {
            _this.editOperand("Before");
        });
        row.querySelector("a[data-editOperAfter]").addEventListener("click", function () {
            _this.editOperand("After");
        });

        row.querySelector("a[data-removerow]").addEventListener("click", function () {
            _this.removerow();
        });

        var td = row.querySelector("td[data-tdobjectcolumn]");
        row.querySelector("td[data-tdobjectcolumn]").addEventListener("click", function () {
            _this.setSelectedRows(td);
        });

        row.querySelector("a[data-moverowup]").addEventListener("click", function () {
            _this.moverowup();
        });
        row.querySelector("a[data-moverowdown]").addEventListener("click", function () {
            _this.moverowdown();
        });
    }

    /*
    removeAttributesID(row) {
        var spanObject = row.querySelector("span[data-objectlabel]");
        if (spanObject != null) {
            spanObject.removeAttribute('attrdescr-tiid');
            spanObject.removeAttribute('attrdescr-contrtiid');
            spanObject.removeAttribute('attrdescr-formula_un');
            spanObject.removeAttribute('attrdescr-channel');
            spanObject.removeAttribute('attrdescr-template');
        }
    }

    setAttributesID(code, id, tr) {
        var spanObject = tr.querySelector("span[data-objectlabel]");
        if (code == 0) {
            spanObject.setAttribute('attrdescr-tiid', id);
        }
        else if (code == 1) {
            spanObject.setAttribute('attrdescr-contrtiid', id);
        }
        else if (code == 2) {
            spanObject.setAttribute('attrdescr-formula_un', id);
        }
        else if (code == 3) {
            spanObject.setAttribute('attrdescr-channel', id)
        }
    }

    */
    /*
    addti(info) {
        document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
            var text = info.split('_');

            var iconObject = tr.querySelector("i[attricon_askue]");
            if (iconObject != null) {
                iconObject.innerHTML = infotp2formulaeditor.ti_Icon;
            }

            var spanObject = tr.querySelector("span[data-objectlabel]");
            if (spanObject != null) {
                spanObject.innerHTML = 'ТИ ФСК: ' + text[0] + ', ' + text[3];
                spanObject.removeAttribute('attrdescr-tiid');
                spanObject.removeAttribute('attrdescr-contrtiid');
                spanObject.removeAttribute('attrdescr-formula_un');
                spanObject.removeAttribute('attrdescr-channel');
                spanObject.setAttribute('attrdescr-tiid', text[1]);
                spanObject.setAttribute('attrdescr-channel', text[2]);
            }
        });
        this.onChangeFormula();
    }

    addcti(info) {
        document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
            var text = info.split('_');

            var iconObject = tr.querySelector("i[attricon_askue]");
            if (iconObject != null) {
                iconObject.innerHTML = infotp2formulaeditor.cti_Icon;
            }

            var spanObject = tr.querySelector("span[data-objectlabel]");
            if (spanObject != null) {
                spanObject.innerHTML = 'ТИ КА: ' + text[0] + ', ' + text[3];
                spanObject.removeAttribute('attrdescr-tiid');
                spanObject.removeAttribute('attrdescr-contrtiid');
                spanObject.removeAttribute('attrdescr-formula_un');
                spanObject.removeAttribute('attrdescr-channel');
                spanObject.setAttribute('attrdescr-contrtiid', text[1]);
                spanObject.setAttribute('attrdescr-channel', text[2]);
            }
        });
        this.onChangeFormula();
    }

    addform(info) {
        document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
            var text = info.split('__');

            var iconObject = tr.querySelector("i[attricon_askue]");
            if (iconObject != null) {
                iconObject.innerHTML = infotp2formulaeditor.function_Icon;
            }

            var spanObject = tr.querySelector("span[data-objectlabel]");
            if (spanObject != null) {
                spanObject.innerHTML = 'Формула: ' + text[0];
                spanObject.removeAttribute('attrdescr-tiid');
                spanObject.removeAttribute('attrdescr-contrtiid');
                spanObject.removeAttribute('attrdescr-formula_un');
                spanObject.removeAttribute('attrdescr-channel');
                spanObject.setAttribute('attrdescr-formula_un', text[1]);
            }
        });
        this.onChangeFormula();
    }

    */
    onLostFocusTbEdit(prefix) {
        var parent = event.currentTarget.parentElement.parentElement;
        var span = parent.querySelector("span[data-spanOper" + prefix + "='']");
        var tb = parent.querySelector("input[data-tbOper" + prefix + "='']");
        span.style.visibility = "visible";
        span.innerHTML = tb.value;
        tb.type = "hidden";
        tb.value = span.innerHTML;
        this.onChangeFormula();
    }

    editOperand(prefix) {
        var parent = event.currentTarget.parentElement.parentElement;
        parent.querySelector("span[data-spanOper" + prefix + "='']").style.visibility = "hidden";
        parent.querySelector("span[data-spanOper" + prefix + "='']").innerHTML = "";
        var tb = parent.querySelector("input[data-tbOper" + prefix + "='']");
        tb.type = "visible";
        tb.focus();
        tb.setSelectionRange(tb.value.length, tb.value.length);
        this.onChangeFormula();
    }

    addrowup() {
        var parent = event.currentTarget.parentElement.parentElement;

        var aDelete = parent.querySelector("a[data-removerow]");
        aDelete.style.visibility = "";

        var currnum = parent.getAttribute('data-rid');
        var newEl = document.querySelector("tr[data-rid='" + currnum + "']").cloneNode(true);
        var table = document.querySelector("table[data-tformuladesc='tformuladesc']");
        var newRow = table.insertRow(currnum);
        newEl.setAttribute("data-newrow", true);

        var spanObject = newEl.querySelector("span[data-objectlabel]");
        spanObject.parentNode.style.backgroundColor = "";
        spanObject.style.fontWeight = "";

        parent.parentElement.insertBefore(newEl, newRow.nextSibling);
        this.setNewRowProps();
        this.setRowNum();
    }

    addrowdown(row) {
        var parent = row ?? event.currentTarget.parentElement.parentElement;

        var aDelete = parent.querySelector("a[data-removerow]");
        aDelete.style.visibility = "";

        var currnum = parent.getAttribute('data-rid');
        var oldel = document.querySelector("tr[data-rid='" + currnum + "']");
        var newel = document.querySelector("tr[data-rid='" + currnum + "']").cloneNode(true);
        newel.setAttribute("data-newrow", true);

        var spanObject = newel.querySelector("span[data-objectlabel]");
        spanObject.parentNode.style.backgroundColor = "";
        spanObject.style.fontWeight = "";

        parent.parentElement.insertBefore(newel, oldel.nextSibling);
        this.setNewRowProps();
        this.setRowNum();
        //this.setSelectedRows(newel.firstChild);
        return newel;
    }

    moverowup() {
        var parent = event.currentTarget.parentElement.parentElement;
        var currnum = parent.getAttribute('data-rid');
        var tbody = document.querySelector("table[data-tformuladesc='tformuladesc']").childNodes[0];
        var firstRow = tbody.rows[currnum - 1];
        var secondRow = tbody.rows[currnum];
        firstRow.parentNode.insertBefore(secondRow, firstRow);
        this.setRowNum();
    }

    moverowdown() {
        var parent = event.currentTarget.parentElement.parentElement;
        var currnum = parent.getAttribute('data-rid');
        var tbody = document.querySelector("table[data-tformuladesc='tformuladesc']").childNodes[0];
        var firstRow = tbody.rows[currnum];
        var secondRow = tbody.rows[Number(currnum) + 2];
        firstRow.parentNode.insertBefore(firstRow, secondRow);
        this.setRowNum();
    }

    removerow() {
        var parent = event.currentTarget.parentElement.parentElement;
        var tableDesc = document.querySelector("table[data-tformuladesc='tformuladesc']");

        var currnum = parent.getAttribute('data-rid');
        if (tableDesc.childNodes[0].childNodes.length > 2) {
            tableDesc.childNodes[0].removeChild(document.querySelector("tr[data-rid='" + currnum + "']"));
            this.setRowNum();
        }

        if (tableDesc.childNodes[0].childNodes.length < 3) {
            var aDelete = tableDesc.childNodes[0].childNodes[1].childNodes[5].querySelector("a[data-removerow]");
            aDelete.style.visibility = "hidden";
        }
        //else {
        //	var row = tableDesc.childNodes[0].childNodes[1];
        //	row.querySelector("data[data-objectlabel]").innerHTML="";
        //	row.querySelector("data[data-spanoperbefore]").innerHTML = "";
        //	row.querySelector("data[data-spanoperafter]").innerHTML = "";
        //	row.querySelector("input[tboperbefore]").innerHTML = "";
        //	row.querySelector("input[tboperafter]").innerHTML = "";
        //	row.querySelector("data[data-tdnum]").innerHTML = "";
        //}
    }

    onChangeFormula() {

        try {
            var tabMathView = document.querySelector("label[id*='_tformulaviewmathtab_label'");
            if (tabMathView != null) tabMathView.setAttribute("data-loaded", "False");

            var tabCalcView = document.querySelector("label[id*='_tformulaviewcalctab_label'");
            if (tabCalcView != null) tabCalcView.setAttribute("data-loaded", "False");

            var table = document.querySelector("table[data-tformuladesc='tformuladesc']");
            var dictDescNew = new Object();
            var rows = table.querySelectorAll("tr[data-rid]");
            rows.forEach(function (tr) {
                var number = tr.getAttribute("data-rid");
                if (!dictDescNew[number])
                    dictDescNew[number] = {};
                dictDescNew[number].Formula_UN = document.querySelector("input[name='formula_un']").value;
                dictDescNew[number].stringnumber = number;
                dictDescNew[number].operBefore = tr.querySelector("span[data-spanoperbefore]").innerText;
                dictDescNew[number].operAfter = tr.querySelector("span[data-spanoperafter]").innerText;
                if (tr.querySelector("span[attrdescr-tiid]") != null)
                    dictDescNew[number].TI_ID = tr.querySelector("span[attrdescr-tiid]").getAttribute("attrdescr-tiid");
                if (tr.querySelector("span[attrdescr-contrtiid]") != null)
                    dictDescNew[number].ContrTI_ID = tr.querySelector("span[attrdescr-contrtiid]").getAttribute("attrdescr-contrtiid");
                if (tr.querySelector("span[attrdescr-formula_un]") != null)
                    dictDescNew[number].UsedFormula_UN = tr.querySelector("span[attrdescr-formula_un]").getAttribute("attrdescr-formula_un");
                if (tr.querySelector("span[attrdescr-formulasource]") != null)
                    dictDescNew[number].UsedFormulaSource = tr.querySelector("span[attrdescr-formulasource]").getAttribute("attrdescr-formulasource");
                if (tr.querySelector("span[attrdescr-channel]") != null)
                    dictDescNew[number].ChannelType = tr.querySelector("span[attrdescr-channel]").getAttribute("attrdescr-channel");
                //Section
                if (tr.querySelector("span[attrdescr-iscontract]") != null)
                    dictDescNew[number].contract_ID = tr.querySelector("span[attrdescr-iscontract]").getAttribute("attrdescr-iscontract");
                if (tr.querySelector("span[attrdescr-iscontractclause]") != null)
                    dictDescNew[number].contract_ID = tr.querySelector("span[attrdescr-iscontractclause]").getAttribute("attrdescr-iscontractclause");
                if (tr.querySelector("span[attrdescr-sectionid]") != null)
                    dictDescNew[number].ei_Section_ID = tr.querySelector("span[attrdescr-sectionid]").getAttribute("attrdescr-sectionid");
                if (tr.querySelector("span[attrdescr-sectiondataid]") != null)
                    dictDescNew[number].EI_SECTION_DATA_ID = tr.querySelector("span[attrdescr-sectiondataid]").getAttribute("attrdescr-sectiondataid");
            });

            if (document.querySelector("input[name='formulajson']") != null)
                document.querySelector("input[name='formulajson']").value = JSON.stringify(dictDescNew);
        }
        catch (exc) {
            console.log(exc);
        };
    }
};

Tango.registerComponent(infotp2formulaeditor, sp => ({
    cu: sp.commonUtils,
    au: sp.ajaxUtils,
    moment: moment,
    btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));
